import styles from "../../styles/PLMApp.module.css";
// src/components/plm/Sidebar.jsx

import SideProgressWidget from "./SideProgressWidget";

export default function Sidebar({ active, onNavigate, steps, supplierId }) {
  const NAV_ITEMS = [
    { key: "activeorders", label: "ACTIVE ORDERS", icon: "◎" },
    { key: "home", label: "DASHBOARD", icon: "⌂" },
    { key: "workflow", label: "WORKFLOW", icon: "◫" },
    { key: "timeline", label: "TIMELINE", icon: "▬" },
    { key: "kanban", label: "KANBAN", icon: "⊞" },
    { key: "documents", label: "DOCUMENTS", icon: "◻" },
    { key: "pastorders", label: "PAST ORDERS", icon: "◈" },
  ];

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sideSection}>
        <div className={styles.sideSectionLabel}>Navigation</div>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.key}
            className={`${styles.sideItem} ${active === item.key ? styles.sideItemActive : ""}`}
            onClick={() => onNavigate(item.key)}
          >
            <span className={styles.sideItemIcon}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </div>

      <SideProgressWidget steps={steps} supplierId={supplierId} />
    </aside>
  );
}
